import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRockingHorse: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRockingHorse"><Path d="M2.5 12V11.5C2.5 9.84315 3.84315 8.5 5.5 8.5H12.9865C14.5 4.5 16.0987 2.5 19.3649 2.5L22 7.39615L20.4189 8.94231L18.3108 7.91154L17.125 9.97308L19.5 19" stroke="currentColor"/><Path d="M7 8.5L4.5 19" stroke="currentColor"/><Path d="M7.25 20.25L9.5 14.5H14.5L16.75 20.25" stroke="currentColor"/><Path d="M2.5 18C8.80002 22.6667 15.2 22.6667 21.5 18" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRockingHorse;
